module.exports = __webpack_public_path__ + "img/desIcon.8f5d44e1.svg";